module.exports = __webpack_public_path__ + "img/37.9.TU.da9d4f78.png";